import axios from "axios";

import type { FieldValues, Path, UseFormSetError } from "react-hook-form";

interface ApiFieldErrorResponse {
  errors?: Record<string, string>;
}

// Map a 400 `{ errors: { field: message } }` response onto the form fields.
// Returns true if at least one field error was applied.
export function applyApiFieldErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  fieldMap: Record<string, Path<T>>,
  translate: (field: string, serverMessage: string) => string,
): boolean {
  if (!axios.isAxiosError(error)) return false;
  const data = error.response?.data as ApiFieldErrorResponse | undefined;
  const errors = data?.errors;
  if (!errors) return false;

  let applied = false;
  Object.entries(errors).forEach(([field, message]) => {
    const formField = fieldMap[field];
    if (!formField) return;
    setError(formField, { message: translate(field, message) });
    applied = true;
  });
  return applied;
}
